module.exports = __webpack_public_path__ + "static/img/noData.34067e0e.svg";